import { createRef, useEffect, useState } from "react";
import Tooltip from "ui/popovers/Tooltip";
import styles from "./TruncatedLabel.module.scss";

interface TruncatedLabelProps extends React.HTMLAttributes<HTMLDivElement> {
  tooltipDelay?: number;
}

export default function TruncatedLabel({ children, title, tooltipDelay = 800, ...props }: TruncatedLabelProps) {
  const [isTruncated, setIsTruncated] = useState(false);
  const containerRef = createRef<HTMLDivElement>();

  useEffect(() => {
    const container = containerRef.current;
    if (!container) {
      return;
    }

    const updateTruncation = () => setIsTruncated(container.offsetWidth < container.scrollWidth);

    updateTruncation();
    const resizeObserver = new ResizeObserver(updateTruncation);
    resizeObserver.observe(container);

    return () => resizeObserver.disconnect();
  }, [children]);

  const tooltipContent = typeof children === "string" ? children : title || "";

  return (
    <Tooltip.Root delayDuration={tooltipDelay}>
      <Tooltip.Trigger asChild>
        <div className={styles.wrapper} {...props} ref={containerRef}>
          {children}
        </div>
      </Tooltip.Trigger>
      {isTruncated && (
        <Tooltip.Content side="top" className={styles.tooltipContent}>
          {tooltipContent}
        </Tooltip.Content>
      )}
    </Tooltip.Root>
  );
}
